import { Link } from 'react-router-dom'
import {
  Button,
  Card,
  Dropdown,
  FormControl,
  FormSelect,
  Table,
} from 'react-bootstrap'
import { useEffect, useState } from 'react'
import Pagination from '../reusable/Pagination'
import fetchData from '../utils/fetchData'
import getCookie from '../utils/getCookie'
import { staticUrl } from '../utils/url'
import formatDate from '../utils/formatDate'
import Delete from './Delete'

const StoreProduct = () => {
  const [storeProducts, setStoreProducts] = useState([])
  const [isDelete, setDelete] = useState(false)
  const [id, setId] = useState()
  const [filter, setFilter] = useState({ search: '', status: '' })
  const [page, setPage] = useState(1)
  const [total, setTotal] = useState(0)
  const [limit] = useState(10)

  const getStoreProducts = async () => {
    try {
      const { data } = await fetchData.get(
        `/storeProduct?page=${page}&limit=${limit}&filter=${JSON.stringify(
          filter
        )}`,
        { headers: { Authorization: `Bearer ${getCookie('eyevaryToken')}` } }
      )
      setTotal(data?.total)
      setStoreProducts(data?.storeProducts)
    } catch (error) {
      console.log({ ...error }, error)
    }
  }
  useEffect(() => {
    getStoreProducts()
  }, [page, limit, filter])
  useEffect(() => {
    setPage(1)
  }, [filter])

  return (
    <section className='content-wrapper'>
      <Delete
        isModal={isDelete}
        setModal={setDelete}
        id={id}
        setId={setId}
        getStoreProducts={getStoreProducts}
      />
      <Card className='mb-4'>
        <Card.Body>
          <div className='d-flex flex-wrap align-items-center justify-content-between'>
            <Card.Title>Store Products</Card.Title>
            <div className='mb-3'>
              <Button as={Link} size='sm' to='/store-products/add'>
                <i className='mdi mdi-plus me-1'></i> Add
              </Button>
            </div>
          </div>
          <div className='filter'>
            <div>
              <FormControl
                type='text'
                placeholder='Search'
                autoComplete='off'
                name='search'
                value={filter.search}
                onChange={({ target }) =>
                  setFilter({ ...filter, [target.name]: target.value })
                }
              />
            </div>
            <div>
              <FormSelect
                name='status'
                value={filter.status}
                onChange={({ target }) =>
                  setFilter({ ...filter, [target.name]: target.value })
                }>
                <option value=''>All</option>
                <option value='true'>Published</option>
                <option value='false'>Unpublished</option>
              </FormSelect>
            </div>
          </div>
          <Table className='text-nowrap' responsive>
            <thead>
              <tr>
                <th scope='col'>Product</th>
                <th scope='col'>Stock / Availability</th>
                <th scope='col'>Price</th>
                <th scope='col'>Discount</th>
                <th scope='col'>Status</th>
                <th scope='col'>Created</th>
                <th
                  scope='col'
                  style={{ maxWidth: '3rem', width: '3rem' }}></th>
              </tr>
            </thead>
            <tbody>
              {storeProducts?.map((item) => (
                <tr key={item?._id}>
                  <td className='align-middle'>
                    <div className='table-img'>
                      <img
                        src={
                          item?.featuredImage
                            ? staticUrl + item?.featuredImage
                            : '/assets/images/product-1.png'
                        }
                        alt={item?.title}
                      />
                      <div>
                        <h6>{item?.title}</h6>
                        <p>
                          {item?.warrantyPeriod || 'Store item'}
                        </p>
                      </div>
                    </div>
                  </td>
                  <td className='align-middle'>
                    {(item?.stock ?? 0) > 0 ? (
                      <span className='badge bg-success'>
                        In Stock ({item?.stock})
                      </span>
                    ) : item?.isPreOrder ? (
                      <span className='badge bg-warning text-dark'>
                        Pre-Order ({item?.advancePercent || 10}%)
                      </span>
                    ) : (
                      <span className='badge bg-danger'>Stock Out</span>
                    )}
                  </td>
                  <td className='align-middle'>৳{item?.price}</td>
                  <td className='align-middle'>{item?.discount || 0}%</td>
                  <td className='align-middle'>
                    {item?.status ? (
                      <span className='status status-outline-success'>
                        Published
                      </span>
                    ) : (
                      <span className='status status-outline-danger'>
                        Unpublished
                      </span>
                    )}
                  </td>
                  <td className='align-middle'>
                    {formatDate({
                      date: item?.createdAt,
                      time: true,
                      divider: ' - ',
                    })}
                  </td>
                  <td className='align-middle text-center'>
                    <Dropdown>
                      <Dropdown.Toggle as='span' className='pnt'>
                        <i className='mdi mdi-dots-vertical'></i>
                      </Dropdown.Toggle>
                      <Dropdown.Menu>
                        <Dropdown.Item
                          as={Link}
                          to={`/store-products/${item?._id}`}>
                          Edit
                        </Dropdown.Item>
                        <Dropdown.Item
                          as='span'
                          className='pnt'
                          onClick={() => {
                            setDelete(true)
                            setId(item?._id)
                          }}>
                          Delete
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>
          <Pagination
            page={page}
            setPage={setPage}
            total={total}
            limit={limit}
          />
        </Card.Body>
      </Card>
    </section>
  )
}

export default StoreProduct
